import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {t} from '../../Translations';
import Button from "../widgets/Button";
import Configuration from "../../Configuration";

/**
 * Component displaying average consumption results
 */
class AverageConsumptionResult extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // Whether the next button is activated or not
        enableNextButton: PropTypes.bool,

        // Whether the consumption is calculation or not
        calculating: PropTypes.bool,

        // The consumption data
        consumption: PropTypes.number,

        // The particles count
        pn: PropTypes.number,

        // The nitrogen data
        nox: PropTypes.number,
        enableButtonconsomation: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        enableNextButton: false,
        calculating: false,
    
    };
    
    render() {
        const {className, enableNextButton, calculating, consumption, pn, nox, onValidate} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        var enableButtonconsomation = "";
        const classes = classNames(
            "cccu-consumption-result",
            {
                [className]: className
            }
        );

        return (
            <div className={classes}>
                <div className={"block cccu-div"+client}>
                    <h4 className="cccu-h4-title">{t('Step1_Result_title')}<sup>(1)</sup></h4>

                    {calculating ? (
                        <p className="consumption-calculating-txt">{t('Step1_form_calcul_in_progress')}</p>
                    ) : (
                        consumption ? (
                            <p className="consumption-result">{consumption.toFixed(1)}{t('Step1_Result_conso_unit')}</p>
                        ) : (
                            <p className="consumption-temp-result">{t('Step1_Result_message_desktop')}</p>
                        )
                    )}

                    <hr />

                    <h4 className="use cccu-h4-title">
                        {t('Step1_Result_CTA_title')}<sup>(2)</sup>
                    </h4>
                
                    {
                        (consumption===undefined) ? (enableButtonconsomation=true) : (enableButtonconsomation=false)
                    }
                    <Button className="btn-result-cccu mt-2" disabled={enableButtonconsomation} onClick={onValidate}>
                        {t('CTA_Next')}
                    </Button>
                </div>
                {(!enableNextButton || (enableNextButton && nox && pn)) ? (
                <div className={"block cccu-p-block"+client}>
                    <p className={"cccu-p p-digital-one"+client}>{t('Step1_Result_emissions_title')}<sup>(3)</sup></p>

                    {calculating ? (
                        <p className="consumption-calculating-txt">{t('Step1_form_calcul_in_progress')}</p>
                    ) : (
                        <React.Fragment>
                            {pn && nox ? (
                                <React.Fragment>
                                    <p className={"consumption-unit-result pn"+client}>{t('Step1_Result_PN_label')} <span>{pn.toFixed(1)} x 10<sup>11</sup> {t('Step1_Result_PN_unit')}</span></p>
                                    <p className={"consumption-unit-result nox"+client}>{t('Step1_Result_Nox_label')} <span>{nox} {t('Step1_Result_Nox_unit')}</span></p>
                                </React.Fragment>
                            ) : (
                                <p className={"consumption-temp-result cccu-p p-digital-one"+client}>{t('Step1_Result_message_desktop')}</p>
                            )}
                        </React.Fragment>
                    )}
                </div>
                ):(
                    <div></div>
                )}
            </div>
                
        )
    }
}
export default AverageConsumptionResult;


// WEBPACK FOOTER //
// ./src/components/steps/AverageConsumptionResult.js